import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ResponsiveTable from '../base/Table/ResponsiveTable';
import Title from '../base/Title/Title';
import ComplaintPositionEmailsTableRow from './ComplaintPositionEmailsTableRow';
import {IS_INTERNAL_APP} from '../../api/ApiSettings';

const ComplaintPositionEmailsTable = ({emails}) => {
    const sendingDateTH = classNames(
        {"col-xs-3 col-sm-2": IS_INTERNAL_APP===true},
        {"col-xs-4 col-sm-2": IS_INTERNAL_APP===false}
    );
    const typeTH = classNames(
        {"col-xs-3 col-sm-3": IS_INTERNAL_APP===true},
        {"col-xs-4 col-sm-5": IS_INTERNAL_APP===false}
    );
    const recipientTH = classNames(
        {"col-xs-3 col-sm-3": IS_INTERNAL_APP===true},
        ""
    );
    const subjectTH = classNames(
        {"col-xs-3 col-sm-4": IS_INTERNAL_APP===true},
        {"col-xs-4 col-sm-5": IS_INTERNAL_APP===false}
    );
    return(
        <div
            className="col-xs-12">
            <Title
                title="Wysłane wiadomości"/>
            <ResponsiveTable
                htmlId="complaintPostionsEmailTable">
                <thead>
                    <tr>
                        <th className={sendingDateTH}>Data wysłania</th>
                        <th className={typeTH}>Typ</th>
                        <th className={subjectTH}>Temat</th>
                        {IS_INTERNAL_APP===true &&
                        <th className={recipientTH}>Odbiorca</th> }
                    </tr>
                </thead>
                <tbody>
                    {emails.map(emailRow =>
                        <ComplaintPositionEmailsTableRow
                            isInternalApp={IS_INTERNAL_APP}
                            emailRow={emailRow}
                            key={emailRow.id} />
                    )}
                </tbody>
            </ResponsiveTable>
        </div>
    );
};

ComplaintPositionEmailsTable.propTypes = {
    emails: PropTypes.array
};

export default ComplaintPositionEmailsTable;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionEmails/ComplaintPositionEmailsTable.js